(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hp_dr_slider"] && !Shopify.designMode) return;
  try {
    
(function() {
  function checkAndHidePagination() {
    const sliderContainer = document.querySelector('.hp_doctors_wrapper .swiper-container');
    if (!sliderContainer) return;
    
    // Pagination might be inside container or in next-prev-arrow div
    let pagination = sliderContainer.querySelector('.swiper-pagination');
    if (!pagination) {
      // Try finding it in the wrapper or next-prev-arrow
      const wrapper = document.querySelector('.hp_doctors_wrapper');
      if (wrapper) {
        pagination = wrapper.querySelector('.swiper-pagination');
      }
    }
    if (!pagination) return;
    
    // Get the actual number of blocks from data attribute
    const blockCount = parseInt(sliderContainer.getAttribute('data-block-count')) || 0;
    if (blockCount === 0) return;
    
    // Determine slidesPerView for current breakpoint (matching pdp-product.js breakpoints)
    let currentSlidesPerView = 1;
    const width = window.innerWidth;
    if (width >= 1024) {
      currentSlidesPerView = 4;
    } else if (width >= 640) {
      currentSlidesPerView = 2;
    } else {
      currentSlidesPerView = 1;
    }
    
    // Hide pagination if all slides fit on screen (no need to slide)
    if (blockCount <= currentSlidesPerView) {
      pagination.classList.add('hide-pagination');
      // Also set inline styles as backup
      pagination.style.display = 'none';
      pagination.style.visibility = 'hidden';
      pagination.style.opacity = '0';
      pagination.style.height = '0';
      pagination.style.margin = '0';
      pagination.style.padding = '0';
    } else {
      pagination.classList.remove('hide-pagination');
      // Reset inline styles
      pagination.style.display = '';
      pagination.style.visibility = '';
      pagination.style.opacity = '';
      pagination.style.height = '';
      pagination.style.margin = '';
      pagination.style.padding = '';
    }
  }
  
  // Check on load and resize
  function initPaginationCheck() {
    // Multiple attempts to catch Swiper initialization
    setTimeout(checkAndHidePagination, 100);
    setTimeout(checkAndHidePagination, 300);
    setTimeout(checkAndHidePagination, 500);
    setTimeout(checkAndHidePagination, 1000);
    
    // Also check on window resize with debounce
    let resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(checkAndHidePagination, 150);
    });
    
    // Try to hook into Swiper events if available
    const sliderContainer = document.querySelector('.hp_doctors_wrapper .swiper-container');
    if (sliderContainer) {
      // Wait a bit for Swiper to initialize, then try to access the instance
      setTimeout(function() {
        if (sliderContainer.swiper) {
          const swiper = sliderContainer.swiper;
          // Listen to Swiper's resize and init events
          swiper.on('resize', checkAndHidePagination);
          swiper.on('init', checkAndHidePagination);
          swiper.on('slideChange', checkAndHidePagination);
          // Check immediately
          checkAndHidePagination();
        } else {
          // Keep trying if Swiper isn't ready yet
          let attempts = 0;
          const checkSwiper = setInterval(function() {
            attempts++;
            if (sliderContainer.swiper || attempts > 20) {
              clearInterval(checkSwiper);
              if (sliderContainer.swiper) {
                const swiper = sliderContainer.swiper;
                swiper.on('resize', checkAndHidePagination);
                swiper.on('init', checkAndHidePagination);
                swiper.on('slideChange', checkAndHidePagination);
                checkAndHidePagination();
              }
            }
          }, 200);
        }
      }, 500);
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPaginationCheck);
  } else {
    initPaginationCheck();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients-slider-Q4-2025"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initIngredientsSlider() {
    const ingredientsSlider = document.querySelector('.ingredients-slider-container');
    const wrapper = document.querySelector('.ingredients-slider-wrapper');
    
    if (ingredientsSlider && wrapper && typeof Swiper !== 'undefined') {
      const swiperInstance = new Swiper(ingredientsSlider, {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        pagination: {
          el: ingredientsSlider.querySelector('.swiper-pagination'),
          clickable: true,
          dynamicBullets: true,
          dynamicMainBullets: 2,
        },
        navigation: {
          nextEl: wrapper.querySelector('.swiper-button-next'),
          prevEl: wrapper.querySelector('.swiper-button-prev'),
        },
        breakpoints: {
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 24,
          },
        },
      });
    } else if (ingredientsSlider && typeof Swiper === 'undefined') {
      // Retry if Swiper hasn't loaded yet
      setTimeout(initIngredientsSlider, 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initIngredientsSlider);
  } else {
    initIngredientsSlider();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["liquid-banner-flavors"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sectionRoot = document.getElementById('shopify-section-{{ section.id }}');
    if (!sectionRoot) return;

    function normalizeId(value) {
      return String(value || '').trim().replace(/^#+/, '');
    }

    function resolveScrollTarget(id) {
      var direct = document.getElementById(id);
      if (direct) return direct;
      var prefixed = document.getElementById('shopify-section-' + id);
      if (prefixed) return prefixed;
      return document.querySelector(
        '[data-section-type="buybox-form"][data-buybox-anchor="' + id + '"]'
      );
    }

    function getStickyHeaderOffset() {
      var header =
        document.getElementById('shopify-section-header') ||
        document.querySelector('.shopify-section-header-sticky, header.header, .header-wrapper');
      if (!header) return 72;
      return header.getBoundingClientRect().height + 16;
    }

    function scrollToTarget(target) {
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var behavior = reducedMotion ? 'auto' : 'smooth';

      if (target.hasAttribute('data-itcf-scroll-anchor')) {
        var top = target.getBoundingClientRect().top + window.pageYOffset - getStickyHeaderOffset();
        window.scrollTo({ top: Math.max(0, top), behavior: behavior });
        return;
      }

      target.scrollIntoView({ behavior: behavior, block: 'start' });
    }

    sectionRoot.addEventListener('click', function (event) {
      var link = event.target.closest('[data-liquid-banner-flavors-scroll]');
      if (!link) return;

      var targetId = normalizeId(link.getAttribute('data-liquid-banner-flavors-scroll'));
      if (!targetId) return;

      var target = resolveScrollTarget(targetId);
      if (!target) return;

      event.preventDefault();
      scrollToTarget(target);

      if (typeof window.showBuyboxCheckout !== 'function') return;

      var buyboxRoot = target.closest('[data-section-type="buybox-form"]');
      if (!buyboxRoot) return;

      var anchor = normalizeId(buyboxRoot.getAttribute('data-buybox-anchor'));
      if (anchor && anchor === targetId) {
        window.showBuyboxCheckout(targetId, { updateHistory: true });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
